export const GROUP_TASK_CHANGED = "group_task_changed";
export const ALL_GROUPS_TASK_CHANGED = "all_groups_task_changed";
